/**
 * Stripe-managed entitlement keys, for Admin copy that names them.
 *
 * @remarks
 * The API enforces these keys from its own dependency-free copy in
 * `services/api/src/service/adminV2/revenueEntitlementKeys.ts`, which Stripe
 * durability CLIs load without this package. A parity test in the API keeps
 * the two lists identical. Overrides for these keys must be scoped to one
 * organisation and carry a future expiry.
 */
export const STRIPE_MANAGED_REVENUE_ENTITLEMENT_KEYS = [
  "revenue_control_plane",
  "learning_billing_context",
  "sales_billing_context",
] as const;
